import axios from 'axios';
export const handleLogin = async () => {
    try {
        const response = await axios.post(
            'https://shipment.xpressbees.com/api/users/login',
            {
                email: 'vaghasiyakishan111@gmail.com',
                password: 'KIshan@1247',
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        const authToken = response?.data?.data;
        return authToken;
    } catch (error) {
        // console.error('Login error:', error);
    }
};